import Dialog from "@mui/material/Dialog";

import ExtractDocumentViewer from "./ExtractDocumentViewer";

// Height of the app's top nav bar (TopHeader `HEADER_HEIGHT`). The modal is
// inset below it so it fills the loan-drilldown content area edge to edge while
// keeping the top nav visible.
export const APP_HEADER_HEIGHT = 64;

/**
 * ExtractTrifoldModal — the full-page extracted-document viewer, opened from a
 * "Parsed" affordance (the uploaded-table chip or the file-preview sidebar).
 * Shared so every entry point renders the same surface.
 *
 * The body is `ExtractDocumentViewer` (top bar + grouped document sidebar +
 * source "paper" + tabbed detail panel, same shape as the tpo-portal-frontend
 * viewer). It owns its own header/close/pager, so this component is just the
 * full-screen dialog shell.
 *
 * Controlled: the caller owns `selectedId` (a parent_document_id) and swaps it
 * via `onSelectId` (used by the sidebar); `onClose` clears it.
 *
 * To revert to the old side-by-side layout, swap ExtractDocumentViewer back for
 * `CompactExtractRail` + `ExtractTriPanel` (both still exported).
 */
export default function ExtractTrifoldModal({
  open,
  dealId,
  documents = [],
  selectedId,
  onSelectId,
  onClose,
  // Passed through to the Fields tab to highlight one extracted field (used by
  // the AI Findings queue to land on the exact field a finding cited).
  focusField,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen
      // Inset below the app's top nav so the modal fills the loan-drilldown
      // content area (edge to edge, square corners) while the nav stays
      // visible. Offset the backdrop to match so it doesn't dim the nav.
      sx={{ top: `${APP_HEADER_HEIGHT}px` }}
      slotProps={{ backdrop: { sx: { top: `${APP_HEADER_HEIGHT}px` } } }}
      PaperProps={{
        sx: {
          m: 0,
          width: "100%",
          maxWidth: "100%",
          height: "100%",
          maxHeight: "100%",
          borderRadius: 0,
        },
      }}
    >
      <ExtractDocumentViewer
        dealId={dealId}
        documents={documents}
        selectedId={selectedId}
        onSelectId={onSelectId}
        onClose={onClose}
        focusField={focusField}
      />
    </Dialog>
  );
}
